import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { Info } from "@material-ui/icons";

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string>;
export const FaciliteitInfo = (props: AllProps) => {
    const label = props.label || "Faciliteit informatie";
    return (<Caption {...props} caption={label} icon={<Info />}>
        {props.value}
    </Caption>)
}
